import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import deepmerge from 'deepmerge';

import { getDefaultPodsPaginationQueryValues } from '../../../core/utils/api_utils';
import { getPodsNotificationData } from '../../../core/utils/notification_utils';
import { getPodsAction, getPodsState } from '../../../features/pod/get_pods';
import useNotification from '../../../core/hooks/use_notification';
import PaginationControls from '../../common/pagination_controls';
import PodsList from '../common/pods_list';
import { GET_ROUTE_POD_ADVERTISEMENTS } from '../../../core/constants';
import AdvertisementsFormDialog from './advertisement_forms/advertisements_form_dialog';
import { getAllPodsAction, getAllPodsState } from '../../../features/pod/get_all_pods';

const initialQueryParams = {
    ...getDefaultPodsPaginationQueryValues
};

const AdvertisementsPage = () => {
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useState(initialQueryParams);
    const { showErrorMessage } = useNotification();

    const getPods = useSelector(getPodsState);
    const getAllPods = useSelector(getAllPodsState);

    useEffect(() => {
        dispatch(getPodsAction(queryParams))
            .then(response => showErrorMessage(getPodsNotificationData(response)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, queryParams]);

    useEffect(() => {
        dispatch(getAllPodsAction())
            .then(response => showErrorMessage(getPodsNotificationData(response)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <Box mb={ 6 }>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={ 4 } flexWrap="wrap"
                   gap={ 2 }>
                <Stack direction="column" spacing={ 0.5 }>
                    <Typography variant="h1" sx={ { m: 0 } }>
                        Reklamy
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" sx={ { fontWeight: 500 } }>
                        Wybierz punkt sprzedaży
                    </Typography>
                </Stack>
                <AdvertisementsFormDialog/>
            </Stack>

            { (getPods?.loading || getAllPods?.loading) && (
                <Box mb={ 2 }>
                    <LinearProgress/>
                </Box>
            ) }

            { (getPods?.data?.content && getAllPods?.data) && (
                <Box>
                    <PodsList route={ GET_ROUTE_POD_ADVERTISEMENTS }/>

                    <Box mt={ 3 } display="flex" justifyContent="center">
                        <PaginationControls
                            currentPage={ getPods?.data?.pageable?.pageNumber }
                            totalPages={ getPods?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }
        </Box>
    );
};

export default AdvertisementsPage;